import { Stack } from '@mantine/core';
import { Icon } from '../../../../lib/components';

export const SortButtons = () => (
  <Stack gap={0}>
    <Icon icon="caret-up" />
    <Icon icon="caret-down" />
  </Stack>
);
